module.exports = __webpack_public_path__ + "static/media/I.846c945b.png";